import React, { useState } from "react";

import { styled } from "@mui/material/styles";
import { useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";

import {
  deleteAllergy,
  getAllergyByID,
} from "../../../Api/Services/AllergyServices";
import { getPetByID } from "../../../Api/Services/PetServices";
import { getPetHistoryById } from "../../../Api/Services/UserServices";
import { PAWPRINT_USER_ROLE_KEY } from '../../../Constant'
import { addItemtoObject } from "../../../Utils";
import ParDataView from "../../Common/PawDataView";
import OwnerInfo from "../OwnerInfo";

export default function AllergyInfoComponent() {
  const { id } = useParams();
  const [petData, setPetData] = useState();
  const navigate = useNavigate();

  const { data: allergyData, isLoading: IsAllergyDataLoading } = useSWR(
    id ? `allergyData${id}` : null,
    async () => {
      const { data } = await getAllergyByID(id);
      if (data?.data?.length) {
        const pet_id = data?.data?.[0].pet_id;
        const { data: petData } = await getPetByID(pet_id);
        setPetData(petData?.data);
      }
      return data?.data?.[0] || [];
    },
    {
      revalidateOnFocus: false,
    }
  );

  const onDelete = async () => {
    return await deleteAllergy(id);
  };

  const { data: allergiesHistory } = useSWR(
    id ? `allergiesHistory${id}` : null,
    async () => {
      try {
        const { data } = await getPetHistoryById("allergy", id);
        const propertiesToUpdate = ['pet_name'];
        const propertiesToDelete = [ 'id', 'pet_id'];
        const filteredData = data?.data?.map((item) => addItemtoObject(item, propertiesToUpdate, propertiesToDelete));
        return filteredData || [];
      } catch (error) {
        console.error('error: ', error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );

  const role = localStorage.getItem(PAWPRINT_USER_ROLE_KEY);
  const props = {
    label: "Allergies",
    isLoading: IsAllergyDataLoading,
    onBack: () => {
      navigate("/allergy");
    },
    petInfo: petData,
    columns: [
      {
        label: "",
        value: "image",
      },
      {
        label: "Pet Name",
        value: "pet_name",
      },
      {
        label: "Allergy type",
        value: "allergy_type",
      },
      {
        label: "Allergy Name",
        value: "allergy_name",
      },
      {
        label: "Reaction",
        value: "reaction",
      },
    ],
    columnsData: [
      {
        image: petData?.image,
        pet_name: petData?.name,
        ...allergyData,
      },
    ],
    detailsData: [[{ name: "Information", value: allergyData?.information }]],
    allowEditOrDelete:
      role === "User" || role === "user" || role === "General Authorized User",
    editLink: `/allergy/edit/${id}`,
    onDelete,
    isHistory: true,
    historyTitle: "Allergies History",
    historyColumnsData: allergiesHistory,
  };

  return (
    <FullPageWrapper>
      <ParDataView {...props} maxLength={1000} />
        <OwnerInfo
          firstName={petData?.userDetails?.first_name}
          lastName={petData?.userDetails?.last_name}
        />
    </FullPageWrapper>
  );
}

const FullPageWrapper = styled("div")(() => ({}));
